import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Komponen ScrollToTop otomatis mereset posisi scroll layar ke paling atas (top: 0, left: 0)
 * setiap kali terjadi perpindahan rute (route navigation).
 * Jika rute mengandung hash target (contoh: #nutrisi-menu), maka akan otomatis diarahkan
 * ke elemen target tersebut.
 */
const ScrollToTop: React.FC = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // Jika terdapat target hash pada URL, arahkan ke elemen tersebut
        if (hash) {
            const element = document.getElementById(hash.replace('#', ''));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
                return;
            }
        }

        // Reset scroll ke koordinat (0, 0) secara instan saat rute berubah
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant' as ScrollBehavior
        });

        if (document.documentElement) {
            document.documentElement.scrollTop = 0;
        }

        if (document.body) {
            document.body.scrollTop = 0;
        }
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
